import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>{t('footer.partnersTitle')}</h3>
          <p>
            <Link to="/partenaires" className="footer-partners-subtitle-link">
              {t('footer.partnersSubtitle')}
            </Link>
          </p>
          <p>
            <a href="mailto:info@oltrefrontiera.ch" className="footer-partners-subtitle-link">
              {t('footer.becomePartner')}
            </a>
          </p>
        </div>

        <div className="footer-section">
          <h3>{t('footer.contactTitle')}</h3>
          <p>
            {t('footer.contactEmailPrefix')}{' '}
            <a href="mailto:info@oltrefrontiera.ch" className="footer-partners-subtitle-link">
              info@oltrefrontiera.ch
            </a>
          </p>
          <p>{t('footer.social')}</p>
          <div className="social-links">
            <a href="https://x.com/JFrontiera" target="_blank" rel="noopener noreferrer" aria-label="X">
              <FaXTwitter />
            </a>
            <a href="https://www.facebook.com/oltrefrontiera/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="https://www.youtube.com/@juventuscluboltrefrontiera9358" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://www.instagram.com/jcoltrefrontiera/reels/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>{t('footer.clubTitle')}</h3>
          <p>{t('footer.clubSubtitle')}</p>
          <a href="/terms" className="footer-link">
            {t('footer.termsLink')}
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.bottom', { year })}</p>
      </div>
    </footer>
  );
};

export default Footer;

